<template lang="pug">
  #CustomerReservationModel.CustomerModel.CustomerModel-reservationModel.overflow-hidden(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .content-header.modal_header.rounded-bottom-1rem.pt-0(
      style="height: 50px;"
    )
      .row.align-items-center.h-100
        .col-10
          h5.mb-0 {{ title }}
        .col-2.d-flex.align-items-center.justify-content-center
          i.iconClose(
            @click="closeModel()"
          )
    .p-3.h-100.overflow-hidden.pt-5(
      style="padding-top: 60px!important;"
    )
      .content
        ValidationObserver(
          ref="form"
          tag="form"
          @submit.stop.prevent="submitHandler"
        )
          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValName"
            )
              label.mb-1(
                for="name"
              )
                span.text-gray 顧客姓名
              b-form-input(
                id="name",
                type="text",
                required,
                trim,
                :state="validState('name')",
                v-model="form.name",
                aria-describedby="input-live-help input-name-live-feedback",
                placeholder="請輸入顧客姓名",
                style="border-radius: 20px;background-color: #eee;"
              )
              b-form-invalid-feedback(
                id="input-name-live-feedback"
              )
                span 此欄不可為空
          b-form-group
            ValidationProvider(
              rules="required|mobile",
              ref="inputValMobile"
            )
              label.mb-1(
                for="mobile"
              )
                span.text-gray 顧客手機
              b-form-input(
                id="mobile",
                type="tel",
                required,
                trim,
                :state="validState('mobile')",
                v-model="form.mobile",
                aria-describedby="input-live-help input-name-live-feedback",
                placeholder="請輸入顧客手機",
                style="border-radius: 20px;background-color: #eee;"
              )
              b-form-invalid-feedback(
                id="input-name-live-feedback"
              )
                span 此欄不可為空
          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValService",
              v-slot="{ errors }"
            )
              label.mb-1(
                for="store"
              )
                span.text-gray 預約服務
              b-form-select(
                id="store",
                required,
                v-model="form.service",
                :state="validState('service')",
                aria-describedby="input-live-help input-name-live-feedback",
                placeholder="請選擇預約服務",
                style="border-radius: 20px;background-color: #eee;",
                @change="changeReservationTypeHandler()"
              )
                template(
                  v-slot:first
                )
                  b-form-select-option(
                    :value="null",
                    disabled
                  ) 請選擇預約服務
                b-form-select-option(
                  v-for="(service,index) in reservationsTypeList",
                  :key="service.id",
                  :value="service.code"
                ) {{ service.name }}
              b-form-invalid-feedback(
                id="input-name-live-feedback"
              )
                span 此欄不可為空
          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValDateId"
            )
              label.mb-1(
                for="dateId"
              )
                span.text-gray 預約日期
              multiselect(
                v-model="form.dateId",
                tag-placeholder="輸入搜尋預約日期",
                placeholder="請選擇預約日期",
                selectedLabel="已選擇",
                selectLabel="點擊新增預約日期",
                deselectLabel="選擇移除預約日期",
                label="RegisterDate",
                track-by="RegisterDate",
                :custom-label="nameWithTimeId",
                :options="reservationTimeList.RegisterDate ? reservationTimeList.RegisterDate : reservationTimeList",
                :allow-empty="false",
                noOptions="無預約日期",
                style="border-radius: 20px;background-color: #eee;"
                @select="selectDatelHandler",
              )
                template(slot="singleLabel", slot-scope="props")
                  span.option__desc
                    span.option__title {{ props.option.RegisterDate }}
                template(slot="option", slot-scope="props")
                  .option__desc
                    span.option__title {{ props.option.RegisterDate }}
                template(slot="noOptions")
                  strong 無預約時段
          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValTimeId"
            )
              label.mb-1(
                for="timeId"
              )
                span.text-gray 預約時段
              multiselect(
                v-model="form.timeId",
                tag-placeholder="輸入搜尋預約時段",
                placeholder="請選擇預約時段",
                selectedLabel="已選擇",
                selectLabel="點擊新增預約時段",
                deselectLabel="選擇移除預約時段",
                label="RegisterDate",
                track-by="RegisterDate",
                :custom-label="nameWithTimeId",
                :options="timeList",
                :allow-empty="false",
                noOptions="無預約時段",
                style="border-radius: 20px;background-color: #eee;",
              )
                template(slot="singleLabel", slot-scope="props, search")
                  span.option__desc
                    span.option__title {{ props.option }}
                template(slot="option", slot-scope="props")
                  .option__desc
                    span.option__title {{ props.option }}
                template(slot="noOptions")
                  strong 無預約時段
      .px-4
        .row.no-gutters
          .col-6.pr-2
            button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
              type="button",
              @click="closeModel()",
              style="important;border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
            ) 取消
          .col-6.pl-2
            button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
              type="button",
              @click="submitHandler()",
              style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
            ) 確認
</template>

<script>
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import { mapState } from 'vuex';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import $ from 'jquery';

const moment = require('moment');
const _ = require('lodash');

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

// 客製化身分證驗證
extend('mobile', {
  validate: (val) => {
    const MobileReg = /^(09)[0-9]{8}$/;
    return MobileReg.test(val);
  },
  message: '行動電話格式錯誤'
});

export default {
  name: 'ReservationModel',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    user: {
      type: [Object, null]
    }
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      form: {
        name: null,
        mobile: null,
        service: null,
        dateId: null,
        timeId: null
      },
      timeList: []
    };
  },
  mounted() {
    this.$EventBus.$on('openReservationModel', () => {
      this.openModel();
      if(this.user) {
        this.form.name = this.user.member_last_name ?
        this.user.member_first_name + this.user.member_last_name : this.user.customer_chinese_first_name + this.user.customer_chinese_last_name; //回填姓名&手機
        this.form.mobile = this.user.member_mobile ? this.user.member_mobile : this.user.mobile; //回填姓名&手機
      }
    });
  },
  methods: {
    nameWithTimeId({ RegisterDate, RegisterSection }) {
      return `預約日期：${RegisterDate}, 預約時段：${RegisterSection}`;
    },
    moment() {
      return moment();
    },
    initHandler() {
      const vm = this;
      vm.$store.commit('sa_reservation/resetReservationTimeList');
      vm.form = {
        name: null,
        mobile: null,
        service: null,
        timeId: null
      };
    },
    openModel() {
      this.initHandler();
      this.showModel = true;
    },
    closeModel() {
      this.$emit('closeModelHandler');
      this.initHandler();
      this.showModel = false;
      $('.icon-back').removeClass('d-none');
    },
    // 檢查欄位
    validState(key) {
      const vm = this;
      // 其餘統一判斷
      if (vm.form[key] !== null) {
        if (key === 'mobile') {
          const MobileReg = /^(09)[0-9]{8}$/;
          return MobileReg.test(vm.form[key]);
        }
        return this.form[key] ? true : false;
      }
      return null;
    },
    // 送出表單
    async submitHandler() {
      const vm = this;
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        if (vm.form.name === null) {
          vm.form.name = '';
        }
        if (vm.form.mobile === null) {
          vm.form.mobile = '';
        }
        if (vm.form.service === null) {
          vm.form.service = '';
        }
        if (vm.form.timeId === null) {
          vm.form.timeId = '';
        }
        vm.$swal.fire({
          icon: 'error',
          title: '請填妥必填欄位或格式輸入錯誤'
        });
      } else {
        vm.$swal.fire({
          title: '表單送出中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });

        const sendData = {
          member_uuid: `${vm.user.member_uuid || vm.user.member_line_uuid}`,
          campaign_code: vm.form.service,
          register_date: vm.form.dateId.RegisterDate,
          register_section: vm.form.timeId,
          register_area: vm.form.dateId.RegisterArea,
          register_name: vm.form.name,
          register_phone: vm.form.mobile
        };

        vm.$store.dispatch('sa_reservation/storeLorealReservationHandler', sendData)
          .then(() => {
            vm.$swal.close();
            vm.closeModel();
          });
      }
    },
    changeReservationTypeHandler() {
      const vm = this;
      if (!vm.form.service || !vm.user || (!vm.user.member_uuid && !vm.user.member_line_uuid)) return;
      vm.$swal.fire({
        title: '取得可預約時間中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_reservation/getReservationTimeListHandler', {
        member_uuid: vm.user.member_uuid || vm.user.member_line_uuid,
        campaign_code: vm.form.service
      })
        .then(() => {
          vm.$swal.close();
        })
        .catch(() => {
          vm.form.timeId = null;
          vm.$store.commit('sa_reservation/resetReservationTimeList');
        });
    },
    selectDatelHandler() {
      const vm = this;

      console.log(vm.form.dateId);
      console.log(vm.form.dateId);
      setTimeout(() => {
        console.log(vm.form.dateId);

        vm.timeList = vm.form.dateId.RegisterSectionList;
      }, 50);
      // vm.timeList = vm.form.dateId.RegisterSectionList;
    }
  },
  computed: {
    ...mapState({
      reservationsTypeList: (state) => state.sa_reservation.reservationsTypeList,
      reservationTimeList: (state) => state.sa_reservation.reservationTimeList
    })
  },
  beforeDestroy() {
    this.$EventBus.$off('openReservationModel');
  }
};
</script>

<style lang="scss" scoped>
  @font-face {
    font-family: "icon";
    src: url("../../assets/fonts/icon.eot?hrpp7d");
    src: url("../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  i {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "icon" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1.2rem;
    margin-bottom: 4px;
  }

  .iconClose:before {
    content: "\e908";
  }
</style>
